export default {
    //'这里填写 leancloud 的 appId',
    id: 'IPzXpIfJRGybfYdhwukxIHxL-9Nh9j0Va',
  
    // '这里填写 leancloud 的 appKey',
    key: '5v3rbLCpKDvVXHuLQCB6qYDX',
  
    // '这里填写 leancloud 的 REST API 服务器地址，国际版应用等未绑定自定义域名的此项留空'
    url: 'https://ipzxpifj.lc-cn-e1-shared.com',
  }  